<div id="safety-app" ng-controller="DevicesCtrl"></div>